module.exports = __webpack_public_path__ + "media/images/lion-94fa434a248624112f7e0299172084ab.jpg";